import { Component, OnInit, Input, OnDestroy } from '@angular/core';
import { SummaryService } from '../services/summary.service';
import { Globals } from '../objects/Globals';
import { PendingItemCount } from '../objects/SummaryObject';
import { Router } from '@angular/router';
import { SwiperConfigInterface } from 'node_modules/ngx-swiper-wrapper';
import { ThemeSettingService } from '../services/theme-setting.service';
import { WorkspaceService } from '../services/workspace.service';

@Component({
  selector: 'app-pendingitem',
  templateUrl: './pendingitem.component.html',
  styleUrls: ['./pendingitem.component.css']
})
export class PendingitemComponent implements OnInit {
  private componentId:string;
  loaderConfig: any;
  pendingItems:PendingItemCount[];
  isBusy:boolean = false;
  noData: boolean;
  
  public config: SwiperConfigInterface = {
    direction: 'horizontal',
    slidesPerView: 4,
    keyboard: true,
    navigation: true,
    pagination: false,
    spaceBetween: 0,
    breakpoints: {
      380: {
        slidesPerView: 2
      },
      768: {
        slidesPerView: 3
      },
      1280: {
        slidesPerView: 4
      }
    }
  };

  @Input() filledSpace:number = 0;

  constructor(private summaryService:SummaryService, private globals:Globals, private router:Router, private themeSettingService:ThemeSettingService, private workspaceService: WorkspaceService) { }

  ngOnInit() {
    this.loaderConfig = this.themeSettingService.getTheme();
    
    if(this.globals.Session){
      this.isBusy = true;
      this.summaryService.createSummaryPendingItems().subscribe(result=>{
        this.componentId = result;
        this.summaryService.getSummaryPendingItems(result).subscribe(pendingList=>{
          this.isBusy = false;
          this.pendingItems = [];
          var items:PendingItemCount[] = JSON.parse(pendingList);
          if (items){
            items = items.filter(x => x.ItemCount != "0");
            this.pendingItems = items.sort(this.sortPendingItems);
          }
        }, error => {
          this.isBusy = false;
        })
      }, error => {
        this.isBusy = false;
      });
    }
  }

  sortPendingItems(a: PendingItemCount,b: PendingItemCount) {
    if (a.ItemSequence < b.ItemSequence)
      return -1;
    if (a.ItemSequence > b.ItemSequence)
      return 1;
    return 0;
  }

  selectPending(type:string){
    this.isBusy = true;
    this.summaryService.selectSummaryPendingItems(this.componentId, type).subscribe(result=>{
      this.handleWorkflowReturn(result);
      this.isBusy = false;
    }, error => {
      this.isBusy = false;
    });
  }

  prevPage(){

  }

  nextPage(){
    
  }

  handleWorkflowReturn(result: any): any {
    var command = JSON.parse(result);
      switch(command.ReturnType){
        case 0: // navigate
          if(command.Arguments){
            var path = [];
            command.Arguments.forEach(element => {
              path.push(element);
            });
            this.router.navigate(path);
          }
          break;
      }
  }
}
